import type { PlatformCapabilities } from './types.js';
import { WebPlatform } from './web.js';

let cached: PlatformCapabilities | null = null;

/**
 * Returns the platform implementation. ADR-021 後 web 端只回 WebPlatform；
 * iOS / Android native 端走 SwiftUI / Compose 各自實作，不經此 abstraction。
 */
export async function getPlatform(): Promise<PlatformCapabilities> {
  if (cached) return cached;
  cached = new WebPlatform();
  return cached;
}

/** Test-only override. */
export function setPlatformForTesting(impl: PlatformCapabilities | null): void {
  cached = impl;
}

export type { PlatformCapabilities, NotifyPayload } from './types.js';
export { PlatformError } from './types.js';
